/* [PATCH izdaja-potrdi-dialog v1] Skupni potrditveni dialog modula Izdaja (namesto window.confirm) — isti videz kot dialog »Izdaj«.
   Uporaba: const [potrdi, potrdiEl] = usePotrdi(); ... if (!(await potrdi({ naslov, besedilo, potrdiNapis, nevarno }))) return; ... {potrdiEl} v JSX. */
import React, { useState } from 'react';
import { AlertTriangle, Check } from 'lucide-react';

export type PotrdiMoznosti = { naslov: string; besedilo?: React.ReactNode; potrdiNapis?: string; prekliciNapis?: string; nevarno?: boolean };
const btn = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-sm';
const btnP = btn + ' bg-blue-600 text-white border-blue-600 hover:bg-blue-700';
const btnD = btn + ' bg-rose-600 text-white border-rose-600 hover:bg-rose-700';
const btnS = btn + ' bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:border-blue-400';

export function usePotrdi(): [(o: PotrdiMoznosti) => Promise<boolean>, React.ReactNode] {
  const [st, setSt] = useState<{ o: PotrdiMoznosti; resolve: (v: boolean) => void } | null>(null);
  const potrdi = (o: PotrdiMoznosti) => new Promise<boolean>(resolve => setSt({ o, resolve }));
  const zakljuci = (v: boolean) => { const s = st; setSt(null); s?.resolve(v); };
  const el = st ? (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4" onClick={() => zakljuci(false)}>
      <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 p-6" onClick={e => e.stopPropagation()}>
        <div className="flex items-start gap-3">
          <div className={'p-2 rounded-full ' + (st.o.nevarno ? 'bg-rose-100 text-rose-600 dark:bg-rose-500/20' : 'bg-blue-100 text-blue-600 dark:bg-blue-500/20')}><AlertTriangle className="w-5 h-5" /></div>
          <div className="min-w-0">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">{st.o.naslov}</h3>
            {st.o.besedilo && <div className="text-sm text-gray-600 dark:text-gray-300 mt-1">{st.o.besedilo}</div>}
          </div>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <button className={btnS} onClick={() => zakljuci(false)}>{st.o.prekliciNapis || 'Prekliči'}</button>
          <button className={st.o.nevarno ? btnD : btnP} autoFocus onClick={() => zakljuci(true)}><Check className="w-4 h-4" /> {st.o.potrdiNapis || 'Potrdi'}</button>
        </div>
      </div>
    </div>
  ) : null;
  return [potrdi, el];
}
